import styled from "styled-components";
import { EventPaginationBox } from "../../../../event/shared/page-layout";

export const TableWrapper = styled.div`
  width: 100%;
  padding: 20px 30px 24px;
  box-sizing: border-box;
  border-radius: 14px;
  border: 0.707px solid #d9d9d9;
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
`;

export const FilterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const SearchBox = styled.div`
  display: flex;
  width: 240px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 15px;
  background-color: #fff;
  padding: 3px 15px;
  box-sizing: border-box;
  align-items: center;

  > input {
    flex: 1;
    border: none;
    outline: none;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
  }

  input::placeholder {
    color: #b7b7b7;
  }

  .searchIcon {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const TableContent = styled.div`
  .name {
    width: 14%;
  }
  .category {
    width: 9%;
  }
  .type {
    width: 12%;
  }
  .period {
    width: 14%;
  }
  .reward {
    width: 14%;
  }
  .createdAt {
    width: 10%;
  }
  .status {
    width: 9%;
  }
  .action {
    width: 18%;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  width: 100%;
  padding: 8px 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #e5e5e5;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 480px;
`;

export const TableItem = styled.div`
  width: 100%;
  display: flex;
  min-height: 52px;
  padding: 10px 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;

  &:last-child {
    border-bottom: none;
  }

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    color: #121212;
    text-align: center;
    word-break: keep-all;
    padding: 0 4px;
  }

  > .item.name {
    font-weight: 600;
  }

  > .item.status {
    .badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 68px;
      height: 26px;
      padding: 0 10px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 700;
      white-space: nowrap;
    }

    .badge.waiting {
      background: #e8f0ff;
      color: #3b6cff;
    }

    .badge.in-progress {
      background: #f3ebff;
      color: #7f25fb;
    }

    .badge.ended {
      background: #f0f0f0;
      color: #969696;
    }
  }

  > .item.action {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: center;

    > button {
      min-width: 44px;
      height: 28px;
      padding: 0 10px;
      border-radius: 6px;
      font-family: Pretendard;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      white-space: nowrap;
    }

    > button.edit {
      border: 1px solid #d9d9d9;
      background: #fff;
      color: #121212;
    }

    > button.end,
    > button.delete {
      border: 1px solid #ff4d4f;
      background: #fff;
      color: #ff4d4f;
    }
  }
`;

export const EmptyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #969696;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
`;

export const PaginationBox = EventPaginationBox;
